<ds-modal [modalInput]="startupModalConfig">
  <div modal-body>
      <div class="info-gradient-box__container mb-12">
        <div class="info-gradient-box__content">
          <h4 class="info-gradient-box__title">{{ "ess_pack_startup_text1" | translate }} {{basicFunctionTrialDays}}-{{ "ess_pack_startup_text2" | translate }}</h4>
          <p class="info-gradient-box__subtitle">{{ "ess_pack_startup_text3" | translate }}</p>
        </div>
      </div>
      <div class="secondary-info-container --borderless mb-12">
        <h6 class="title-14">{{ "ess_pack_startup_text4" | translate }}</h6>
        <div class="info-text__container setup-info-text__container">
          <span class="step-count">1</span>
          <div class="info-text__content">
            <h6>{{ "ess_pack_startup_text5" | translate }}</h6>
            <p>{{ "ess_pack_startup_text6" | translate }}<span>{{ "ess_pack_startup_text7" | translate }}</span></p>
          </div>
        </div>
        <div class="info-text__container setup-info-text__container">
          <span class="step-count">2</span>
          <div class="info-text__content">
            <h6>{{ "ess_pack_startup_text8" | translate }}</h6>
            <p>{{ "ess_pack_startup_text9" | translate }}<span>{{ "ess_pack_startup_text10" | translate }}</span></p>
          </div>  
        </div>
      </div>
      <div class="secondary-info-container --borderless mb-12">
        <ul class="ds-info-text --icon-check --success">
          <li>{{'ess_pack_startup_text11' | translate}}</li>  
          <li>{{'ess_pack_startup_text12' | translate}}</li>
          <li>{{'ess_pack_startup_text13' | translate}}</li>
        </ul>
      </div>
      <!--   -->
      <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
        <ds-button [buttonInput]="continueButtonConfig" (click)="fnOnContinue()"></ds-button>
        <p class="paragraph-12">{{ "ess_pack_startup_text14" | translate }}</p>
      </div>
  </div>
</ds-modal>